import { IthHelmet } from "@/components"
import {
  getWorktimeDailyDetailApi,
  updateTimeEntries,
} from "@/services/apis/worktimeDaily"
import { useRequest } from "ahooks"
import styles from "../worktime.module.scss"
import { Breadcrumb, Button, Card, Select, Spin } from "antd"
import React, { Fragment, useEffect, useMemo, useState } from "react"
import { Link, useParams, useLocation, useSearchParams } from "react-router-dom"
import { useNavigate } from "react-router-dom"
import clsx from "clsx"
import EditDailyTd from "../components/editDailyTd"
import { k_pageType } from "./hook"
import { LeftCircleOutlined } from "@ant-design/icons"

const Index = () => {
  
  const navigate = useNavigate()
  const [queryParams] = useSearchParams()
  const pageType = queryParams.get("pageType") || ""

  const { userID, currentDate } = useParams()

  // useRequest getWorktimeDailyDetailApi
  // 当前编辑ID
  const [currentEdit, setCurrentEdit] = useState<number>(0)
  const [editWeekdays, setEditWeekdays] = useState<
    Map<string, API.WorktimeDaily.timeEntry>
  >(new Map())
  const {
    data: dailyInfo,
    loading,
    refresh,
    run: runGetWorktimeDailyDetailApi,
  } = useRequest(getWorktimeDailyDetailApi, {
    manual: true,
    onSuccess: () => {
      setCurrentEdit(0)
      setEditWeekdays(new Map())
    },
  })
  // updateTimeEntries useRequest
  const { run: runUpdateTimeEntries } = useRequest(updateTimeEntries, {
    manual: true,
    onSuccess: () => {
      setCurrentEdit(0)
      setEditWeekdays(new Map())
      refresh()
    },
  })

  const onChangeMember = (val: number) => {
    navigate(`/worktime/users/${val}/currentDate/${currentDate}?pageType=${pageType}`)
  }

  const saveWorktime = () => {
    if (editWeekdays.size <= 0) return
    const items = Array.from(editWeekdays.values())
    runUpdateTimeEntries({
      items: items,
    })
  }

  const onWorktimeInputChange = (
    dayItem: API.WorktimeDaily.timeEntry,
    val: number
  ) => {
    setEditWeekdays(
      (v) => new Map(v.set(dayItem.id.toString(), { ...dayItem, hours: val }))
    )
  }

  useEffect(() => {
    if (userID && currentDate) {
      runGetWorktimeDailyDetailApi(userID, currentDate, pageType)
    }
  }, [userID, currentDate])

  const memberOptions = useMemo(() => {
    return (dailyInfo?.users || []).map((v) => ({
      value: v.id,
      label: v.name,
    }))
  }, [dailyInfo?.users])

  const dailyData = useMemo(() => {
    let allTotal = 0
    const totalColumns = (dailyInfo?.dates || []).map((v) => {
      return {
        designHours: 0,
        commuHours: 0,
        travelHours: 0,
        biHours: 0,
        spentOn: v.spentOn,
      }
    })

    // 项目合计DateColumns
    const projects = dailyInfo?.projects?.map((v) => {
      let total = 0
      const dateTotalColumns = (dailyInfo?.dates || []).map((v) => {
        return {
          designHours: 0,
          commuHours: 0,
          travelHours: 0,
          biHours: 0,
          spentOn: v.spentOn,
          id: 0,
        }
      })
      const packages = v.packages?.map((v) => {
        let totalHours = 0
        v.dates.forEach((vd, i) => {
          if(!vd.timeEntries) return
          vd.timeEntries?.forEach((v, k) => {
            totalHours += v.hours
            if (v.activityID === 2) {
              dateTotalColumns[i].designHours += v.hours
              totalColumns[i].designHours += v.hours
            } else if (v.activityID === 1) {
              dateTotalColumns[i].commuHours += v.hours
              totalColumns[i].commuHours += v.hours
            } else if (v.activityID === 18) {
              dateTotalColumns[i].travelHours += v.hours
              totalColumns[i].travelHours += v.hours
            }

            dateTotalColumns[i].id = v.id + k

            if (!dateTotalColumns[i].biHours) {
              dateTotalColumns[i].biHours = vd.biHours
            }
            total += v.hours
            allTotal += v.hours
            // 编辑数据
            if (editWeekdays.has(v.id.toString())) {
              v.hours = editWeekdays.get(v.id.toString())?.hours || v.hours
            }
          })
        })
        return {
          ...v,
          totalHours: totalHours,
        }
      })
      return {
        ...v,
        dateTotalColumns,
        packages,
        total,
      }
    })
    return {
      projects: projects || [],
      totalColumns,
      allTotal,
    }
  }, [dailyInfo, editWeekdays])

  const renderTdItem = (item: API.WorktimeDaily.timeEntry, className = "") => {
    // 只有专负可以编辑，设总不能编辑 pageType === 'zc' && v.status === 0, 只有1不能编辑
    if (item.status === 1) {
      return (
        <td key={item.activityID} className={`text-gray-300 ${className}`}>{item.hours}</td>
      )
    }
    return (
      <EditDailyTd
        key={item.activityID}
        data={item}
        onChange={(val) => onWorktimeInputChange(item, val)}
        onEdit={() => setCurrentEdit(item.id)}
        editID={currentEdit}
      >
      </EditDailyTd>
    )
  }

  const renderTypeEntryItem = (v: API.WorktimeDaily.date) => {
    const item = v.timeEntries
    if (item && item.length === 3) {
      // 只有专负可以编辑，设总不能编辑 pageType === 'zc' && v.status === 0, 只有1不能编辑      
      return <>
        {renderTdItem(item[1], "b-l")} 
        {renderTdItem(item[0])} 
        {renderTdItem(item[2], "b-r")}
      </>
    } else {
      return (
        <>
          <td className="b-l text-gray-300">0</td>
          <td className="text-gray-300">0</td>
          <td className="b-r text-gray-300">0</td>
        </>
      )
    }
  }

  const reset = () => {
    // 刷新页面
    window.location.reload()
  }

  // 单项目渲染
  const renderProjectItem = (item: (typeof dailyData.projects)[0]) => {
    return (
      <React.Fragment key={item.id}>
        {item.packages?.map((v, i) => (
          <tr key={v.id} className="text-center">
            {i === 0 && (
              <Fragment>
                <td rowSpan={item.packages.length}>项目</td>
                <td rowSpan={item.packages.length}>{item.code}</td>
                <td rowSpan={item.packages.length}>{item.name}</td>
              </Fragment>
            )}
            <td>{v.name}</td>
            <td className="b-r">{v.totalHours}</td>
            {v.dates.map((day, i) => {
              return (
                <Fragment key={i}>
                  {renderTypeEntryItem(day)}
                </Fragment>
              )
            })}
          </tr>
        ))}
        <tr className="bg-gray-200 font-bold text-center">
          <td colSpan={4}>项目合计</td>
          <td className="font-bold b-r">{item.total}</td>
          {item.dateTotalColumns.map((v, i) => (
            <Fragment key={v.spentOn + i}>
              <td
                key={"design" + v.id}
                className={clsx(
                  "font-bold whitespace-nowrap b-l",
                  v.designHours <= 0 && "text-gray-300"
                )}
              >
                {v.designHours}
                {v.biHours > 0 && (
                  <span className="text-red-400">（{v.biHours}）</span>
                )}
              </td>
              <td
                key={"commu" + v.id}
                className={clsx(
                  "font-bold whitespace-nowrap",
                  v.commuHours <= 0 && "text-gray-300"
                )}
              >
                {v.commuHours}
              </td>
              <td
                key={"travel" + v.id}
                className={clsx(
                  "font-bold whitespace-nowrap b-r",
                  v.travelHours <= 0 && "text-gray-300"
                )}
              >
                {v.travelHours}
              </td>
            </Fragment>
          ))}
        </tr>
      </React.Fragment>
    )
  }
  return (
    <>
      <Card>
        <IthHelmet pageTitle="工时填报明细" report />

        <Breadcrumb
          items={[
            {
              key: "list",
              title: (
                <Link to={`/worktime?currentDate=${currentDate}&pageType=${pageType}`}>
                  <LeftCircleOutlined />
                  工时审批列表
                </Link>
              ),
            },
            {
              key: "detail",
              title: "工时填报明细",
            },
          ]}
        />

        <div>
          <div className="flex justify-between items-center my-4">
            <div className="flex items-center">
              <div className="mr-2">当前设计师工时明细</div>
              <Select
                className="w-40"
                placeholder="请选择设计师"
                value={Number(userID)}
                options={memberOptions}
                onChange={onChangeMember}
              ></Select>
              <div className="text-gray-700 font-bold ml-8">
                期间 {dailyInfo?.subject}
              </div>
            </div>
            {(
              <div>
                <Button className="mr-4" onClick={reset}>
                  重置
                </Button>
                <Button
                  onClick={saveWorktime}
                  disabled={editWeekdays.size <= 0}
                  type="primary"
                >
                  保存
                </Button>
              </div>
            )}
          </div>
          <Spin spinning={loading}>
            <div className={styles.tableContainer}>
              <table className={styles.borderTable}>
                <colgroup>
                  <col style={{ minWidth: 80 }} />
                  <col style={{ minWidth: 100 }} />
                  <col style={{ minWidth: 100 }} />
                  <col style={{ minWidth: 100 }} />
                  <col style={{ minWidth: 80 }} />
                  {dailyInfo?.dates.map((v) => (
                    <React.Fragment key={v.spentOn}>
                      <col
                        key={"design" + v.spentOn}
                        style={{ minWidth: 80 }}
                      />
                      <col key={"commu" + v.spentOn} style={{ minWidth: 80 }} />
                      <col key={"travel" + v.spentOn} style={{ minWidth: 80 }} />
                    </React.Fragment>
                  ))}
                </colgroup>
                <tbody className="text-center">
                  <tr className="text-center">
                    <td rowSpan={2}>分类</td>
                    <td rowSpan={2}>项目编号</td>
                    <td rowSpan={2}>项目名称</td>
                    <td rowSpan={2}>工作包</td>
                    <td rowSpan={2} className="b-r">
                      合计
                    </td>
                    {dailyInfo?.dates.map((v) => (
                      <td
                        key={v.spentOn}
                        colSpan={3}
                        className={clsx(
                          "b-l b-r",
                          currentDate === v.spentOn && "bg-gray-200",
                          v.status === -1 && "text-gray-300"
                        )}
                      >
                        {v.spentOn}
                        {(() => {
                          if (pageType === "zc") {
                            switch (v.status) {
                              case 0:
                                return (
                                  <span className="text-red-700">(未审批)</span>
                                )
                              case 1:
                                return (
                                  <span className="text-gray-400">
                                    (已审批)
                                  </span>
                                )
                              case 2:
                                return (
                                  <span className="text-red-400">(有更新)</span>
                                )
                            }
                          } else {
                            switch (v.paStatus) {
                              case 0:
                                return (
                                  <span className="text-red-700">(未审批)</span>
                                )
                              case 1:
                                return (
                                  <span className="text-gray-400">
                                    (已审批)
                                  </span>
                                )
                              case 2:
                                return (
                                  <span className="text-red-400">(有更新)</span>
                                )
                            }
                          }
                        })()}
                      </td>
                    ))}
                  </tr>
                  <tr className="text-center">
                    {dailyInfo?.dates.map((v) => (
                      <Fragment key={v.spentOn}>
                        <td
                          className={clsx(
                            "b-l",
                            v.status === -1 && "text-gray-300"
                          )}
                        >
                          设计
                        </td>
                        <td
                          className={clsx(
                            "",
                            v.status === -1 && "text-gray-300"
                          )}
                        >
                          沟通
                        </td>
                        <td
                          className={clsx(
                            "b-r",
                            v.status === -1 && "text-gray-300"
                          )}
                        >
                          差旅
                        </td>
                      </Fragment>
                    ))}
                  </tr>
                  {dailyData.projects?.map((v) => renderProjectItem(v))}
                  <tr className="bg-gray-200 font-bold">
                    <td colSpan={4}>合计</td>
                    <td className="font-bold b-r">{dailyData.allTotal}</td>
                    {dailyData.totalColumns.map((v) => (
                      <Fragment key={v.spentOn}>
                        <td
                          key={"design" + v.spentOn}
                          className={clsx(
                            "font-bold b-l",
                            v.designHours <= 0 && "text-gray-300"
                          )}
                        >
                          {v.designHours}
                        </td>
                        <td
                          key={"commu" + v.spentOn}
                          className={clsx(
                            "font-bold",
                            v.commuHours <= 0 && "text-gray-300"
                          )}
                        >
                          {v.commuHours}
                        </td>
                        <td
                          key={"travel" + v.spentOn}
                          className={clsx(
                            "font-bold b-r",
                            v.travelHours <= 0 && "text-gray-300"
                          )}
                        >
                          {v.travelHours}
                        </td>
                      </Fragment>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </Spin>
        </div>
      </Card>
    </>
  )
}

export default Index
